import { render } from "./achievementEvelutionDetailNew.vue?vue&type=template&id=7047cb3e&scoped=true"
import script from "./achievementEvelutionDetailNew.vue?vue&type=script&lang=js"
export * from "./achievementEvelutionDetailNew.vue?vue&type=script&lang=js"

import "./achievementEvelutionDetailNew.vue?vue&type=style&index=0&id=7047cb3e&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7047cb3e"]])

export default __exports__